import { Search } from 'lucide-react';

export function SearchBar({
  id = 'search',
  value,
  onChange,
  placeholder = 'Search…',
  label = 'Search',
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
}): JSX.Element {
  return (
    <div className="search-bar">
      <Search className="search-bar__icon" size={16} strokeWidth={2} aria-hidden />
      <label htmlFor={id} className="visually-hidden">
        {label}
      </label>
      <input
        id={id}
        type="search"
        className="search-bar__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
